import {useDispatch, useSelector} from "react-redux";
import {financeSelector} from "../../../../redux/slices/financeSlice";
import {globalDataSelector, setNegativeBalancePopup} from "../../../../redux/slices/globalDataSlice";
import {useTranslation} from "react-i18next";
import React, {useEffect} from "react";
import s from './negativeBalancePopup.module.scss'
import SvgSelector from "../../../SvgSelector/SvgSelector";
import BaseTextInput from "../../../BaseTextInput/BaseTextInput";
import {snackbar_info} from "../../../../utils/vars/staticVariables";

const NegativeBalancePopup = () => {
    const { wallet, topUpBalanceIsActive } = useSelector(financeSelector);
    const { exitPopup, isCollapsedSidebar, isNegativeBalancePopupActive } = useSelector(globalDataSelector);

    const dispatch = useDispatch()

    const { t } = useTranslation();

    const handleClosePopup = (event) => {
        if (event.target.classList.contains(s.popupWrapper)) {
            dispatch(setNegativeBalancePopup(false));
        }
    };

    useEffect(() => {
        if (topUpBalanceIsActive || exitPopup) {
            dispatch(setNegativeBalancePopup(false));
        }
    }, [topUpBalanceIsActive, exitPopup, dispatch]);

    const handleWrapperClick = (event) => {
        if (event.target.classList.contains(s.popupWrapper)) {
            handleClosePopup(event);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // setActive(false);
        dispatch(setNegativeBalancePopup(false));
        // action();
    };

    useEffect(() => {
        const handleEscClose = (e) => {
            if (e.key === "Escape") {
                // setActive(false);
                dispatch(setNegativeBalancePopup(false));
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            }
        };
        const handleEnterPress = (e) => {
            if (e.key === "Enter") {
                if (document.activeElement) {
                    document.activeElement.blur();
                }
                handleSubmit(e);
            }
        };
        if (isNegativeBalancePopupActive) {
            document.addEventListener("keydown", handleEscClose);
            document.addEventListener("keydown", handleEnterPress);
        }

        return () => {
            document.removeEventListener("keydown", handleEscClose);
            document.removeEventListener("keydown", handleEnterPress);
        };
    }, [isNegativeBalancePopupActive]);


    return (
        <div
            className={`${s.popupWrapper} ${isNegativeBalancePopupActive ? s.active : ""} ${isCollapsedSidebar === "true" ? s.collapsed : ""}`}
            onClick={handleWrapperClick}
        >
            <div
                className={isNegativeBalancePopupActive ? `${s.popup} ${s.active}` : s.popup}
            >
                <div className={s.header}>
                    <button
                        onClick={() => dispatch(setNegativeBalancePopup(false))}
                        className={s.closePopup}
                        type="button"
                    >
                        <SvgSelector id="close-popup" />
                    </button>
                    <div className={s.icon}>
                        <SvgSelector id="negative-balance-popup-icon" />
                    </div>
                    <div className={s.popupInfo}>
                        <p className={s.title}>{t('wallet_negative_balance_header')}</p>
                    </div>
                </div>
                <div className={s.body}>
                    <div className={s.descriptions}>
                        <p className={s.mainDescription}>
                            {t('wallet_insufficient_funds_message')}
                        </p>
                        <p className={s.subdescription}>
                            {t('wallet_top_up_and_retry_message')}
                        </p>
                    </div>
                    <div className={s.copyInputContainer}>
                        <p className={s.inputDesc}>{t("crypto_wallet")}(USDT TRC20)</p>
                        <BaseTextInput
                            value={wallet}
                            placeholder={t("loading")}
                            copy={true}
                            alertMessage={t("notif_crypto_wallet_copied")}
                            alertType={snackbar_info}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NegativeBalancePopup;